export default __webpack_public_path__ + "static/background-924331f8120ebd88f68c178f0798123a.jpg";